import React from "react";
import QtyInput from "../../components/Reusable/QtyInput";
import { fetchAddToCart } from "../../actions/catalog";
import InfoBox from "../../components/Reusable/InfoBox";
import { useDispatch } from "react-redux";
import { t } from "i18next"; // Import t function for translation

const CatalogListItems = (props) => {
  const { data } = props;
  const dispatch = useDispatch();

  const addToCart = (product, newQty) => {
    const item = {
      productId: product.productId,
      quantity: newQty,
    };

    dispatch(fetchAddToCart(item));
  };

  return (
    <div className="products-list-container">
      {/* {data?.length === 0 ? (
        <InfoBox text={t("catalogListItems.noProductsDefined")} />
      ) : ( */}
      <ul>
        <div className="product-list-items">
          {data?.map((product, key) => (
            <div className="product-list-item" key={key}>
              <div className="product-list-item-context">
                <div className="product-list-item-title">
                  {product?.promotionPoints !== null && product?.promotionPoints > product?.points && (
                    <img
                      src="/images/fire.png"
                      className="img-fluid"
                      alt="Promotion"
                    />
                  )}
                  {product.name}
                </div>
                <div className="product-list-item-points">
                  <div className="product-list-item-points-item">
                    {t("catalogListItems.points")}{" "}
                    <span className={product?.promotionPoints !== null && "points"}>
                      {product.points}
                    </span>
                    {product?.promotionPoints !== null && (
                      <span className="promotion-points">
                        {product?.promotionPoints}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="product-list-item-qty">
                <QtyInput
                  value={1}
                  onChange={(newQty) => addToCart(product, newQty)}
                />
              </div>
            </div>
          ))}
        </div>
      </ul>
      {/* )} */}
    </div>
  );
};

export default CatalogListItems;
